import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NewUpdateScreenComponent } from './new-update-screen.component';


@NgModule({
  declarations: [NewUpdateScreenComponent],
  imports: [CommonModule, FormsModule],
  exports: [NewUpdateScreenComponent],
})
export class NewUpdateScreenModule {}
